<template>
  <div class="box">
    <div class="container">
      <div class="section banner">
        <img :src="banner+'1.jpg'" alt="" class="section-banner">
        <div class="banner-text">
          <h6 class="banner-text-h6">位讯旅游</h6>
          <p class="banner-text-p">关注导游 关注体验</p>
          <div class="download-box">
            <a href="https://itunes.apple.com/cn/app/id1346476029?mt=8" target="_blank" class="download">iPhone下载</a>
            <a href="http://sj.qq.com/myapp/detail.htm?apkName=com.liexingtravelassistant" target="_blank" class="download">Android下载</a>
            <img :src="hkmovie" alt="" class="download-hkmovie">
          </div>
        </div>
      </div>
      <div class="section stroke">
        <div class="stroke-text">
          <h1>行程管理</h1>
          <h2><span>为导游和游客提供能更圆满完成</span><br /><span>旅行的管理工具</span></h2>
          <img :src="stroke+'1.png'" alt="">
        </div>
        <img :src="showPhone+'1.png'" alt="" class="showPhone">
      </div>
      <div class="section banner">
        <img :src="banner+'2.jpg'" alt="" class="section-banner">
        <div class="banner-text">
          <p class="banner-text-p2">让旅游变得更<br />简单</p>
        </div>
      </div>
      <div class="section stroke">
        <div class="stroke-text">
          <h1>分享故事</h1>
          <h2><span>聆听旅游达人有趣的故事，分享您的</span><br /><span>旅行体验</span></h2>
          <img :src="stroke+'2.png'" alt="">
        </div>
        <img :src="showPhone+'2.png'" alt="" class="showPhone showPhone2">
      </div>
      <div class="section banner">
        <img :src="banner+'3.jpg'" alt="" class="section-banner">
        <div class="banner-text">
          <p class="banner-text-p2">让每一寸土地 <br />都有故事</p>
        </div>
      </div>
      <div class="section stroke">
        <div class="stroke-text">
          <h1>关注导游</h1>
          <h2><span>在这里，有资深的导游为您带来不一样</span><br /><span>的旅行体验</span></h2>
          <img :src="stroke+'3.png'" alt="">
        </div>
        <img :src="showPhone+'3.png'" alt="" class="showPhone">
      </div>
      <div class="section banner">
        <img :src="banner+'4.jpg'" alt="" class="section-banner">
        <div class="banner-text">
          <p class="banner-text-p2">寻找喜欢的导游 <br />为您服务</p>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      sendSelected:'download',
      colourClass:'',
      banner: 'static/images/section-banner',
      hkmovie: 'static/images/hkmovie2.png',
      stroke: 'static/images/stroke',
      showPhone: 'static/images/show-phone',
    }
  },
  mounted(){
    this.$emit('nav',this.sendSelected,this.colourClass);
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  // 产品介绍列
  .container {
    .section {
      height: 610px;
      box-sizing: border-box;
    }
    .banner{
      position: relative;
      overflow: hidden;
      width: 100%;
      min-width: 1200px;
      .section-banner{
        position: relative;
        width: 1920px;
        max-width: initial;
        left: 50%;
        margin-left: -960px;
      }
      .banner-text{
        position: absolute;
        height: 100%;
        width: 1200px;
        top: 0;
        left: 50%;
        margin-left: -600px;
        .banner-text-h6{
          color: #fff;
          font-size: 60px;
          font-weight: 400;
          line-height: 68px;
          margin-top: 180px;
        }
        .banner-text-p{
          color: #fff;
          font-size: 60px;
          font-weight: 100;
          line-height: 68px;
          margin: 30px 0 50px;
        }
        .banner-text-p2{
          color: #fff;
          font-size: 60px;
          font-weight: 100;
          line-height: 72px;
          margin-top: 250px;
          text-align: center;
          letter-spacing: 12px;
          text-shadow: 0px 6px 4px rgba(0,0,0,0.1);
        }
        .download-box{
          // margin-top: 400px;
          .download{
            display: inline-block;
            height: 52px;
            line-height: 52px;
            border-radius: 30px;
            padding: 0 30px 0 70px;
            background:#fff url('../assets/images/iphone.png') 30px center no-repeat;
            font-size: 18px;
            color: #515151;
            margin-right: 30px;
            &:nth-of-type(2){
              background-image: url('../assets/images/android.png');
            }
            &:hover{
              opacity: 0.8;
            }
          }
          .download-hkmovie{
            margin-top: -10px;
          }
        }
        
        
      }
    }
    .stroke{
      height: 650px;
      width: 790px;
      margin: 0 auto;
      position: relative;
      overflow: hidden;
      .stroke-text{
        width: 480px;
        margin-top: 190px;
        h1 {
          color: #4d4d4d;
          font-size: 48px;
          line-height: 50px;
        }
        h2 {
          color: #666;
          margin-top: 30px;
          font-size: 22px;
          margin-bottom: 40px;
          line-height: 40px;
        }
      }
      .showPhone{
        position: absolute;
        right: 0;
        bottom: -76px;
        &.showPhone2{
          bottom: initial;
          top: 50%;
          margin-top: -256px;
        }
      }
    }
    
  }
</style>



// WEBPACK FOOTER //
// src/components/download.vue